var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36156 10.1105C3.36156 11.0356 2.60586 11.7913 1.68078 11.7913C0.755701 11.7913 0 11.0356 0 10.1105C0 9.18539 0.755701 8.42969 1.68078 8.42969H3.36156V10.1105Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20847 10.1105C4.20847 9.18539 4.96417 8.42969 5.88925 8.42969C6.81433 8.42969 7.57003 9.18539 7.57003 10.1105V14.3189C7.57003 15.244 6.81433 15.9997 5.88925 15.9997C4.96417 15.9997 4.20847 15.244 4.20847 14.3189V10.1105Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88925 3.36156C4.96417 3.36156 4.20847 2.60586 4.20847 1.68078C4.20847 0.755701 4.96417 0 5.88925 0C6.81433 0 7.57003 0.755701 7.57003 1.68078V3.36156H5.88925Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88925 4.20898C6.81433 4.20898 7.57003 4.96468 7.57003 5.88977C7.57003 6.81485 6.81433 7.57055 5.88925 7.57055H1.68078C0.755701 7.57055 0 6.81485 0 5.88977C0 4.96468 0.755701 4.20898 1.68078 4.20898H5.88925Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6384 5.88977C12.6384 4.96468 13.3941 4.20898 14.3192 4.20898C15.2443 4.20898 16 4.96468 16 5.88977C16 6.81485 15.2443 7.57055 14.3192 7.57055H12.6384V5.88977Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7915 5.88925C11.7915 6.81433 11.0358 7.57003 10.1107 7.57003C9.18566 7.57003 8.42996 6.81433 8.42996 5.88925V1.68078C8.42996 0.755701 9.18566 0 10.1107 0C11.0358 0 11.7915 0.755701 11.7915 1.68078V5.88925Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1107 12.6367C11.0358 12.6367 11.7915 13.3924 11.7915 14.3175C11.7915 15.2426 11.0358 15.9983 10.1107 15.9983C9.18563 15.9983 8.42993 15.2426 8.42993 14.3175V12.6367H10.1107Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1107 11.7913C9.18566 11.7913 8.42996 11.0356 8.42996 10.1105C8.42996 9.18539 9.18566 8.42969 10.1107 8.42969H14.3192C15.2443 8.42969 16 9.18539 16 10.1105C16 11.0356 15.2443 11.7913 14.3192 11.7913H10.1107Z",
    fill: "#ECB22E"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Slack.3da4b0d512829d12f5dd71c2af28cbe9.svg";